export {default} from "../patterngalleries/CategoryPatterns";



// WEBPACK FOOTER //
// ./src/components/async/CategoryPatterns.js